import { createApiCall2, MethodType, URI } from "../Api";
import { IConsultationListPayload } from "models/consultation/list";

export const fetchConsultationList = (payload: IConsultationListPayload) => {
  return createApiCall2(MethodType.GET, URI.CONSULTATION.LIST, payload);
};
